/**
 * Navigation related functionality
 * @module navigation
 */

const SVG_ARROW = '<svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="currentColor" viewBox="0 0 320 512"><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/></svg>';

/**
 * Initializes navigation elements and handlers
 */
export function initializeNavigation() {
  // Add arrows to links
  document.querySelectorAll('.is-style-link:not(:has(*)), .is-style-link:has(.screen-reader-text), .wp-block-button.is-style-link .wp-block-button__link')
          .forEach(elem => elem.insertAdjacentHTML('beforeend', SVG_ARROW));

  // Setup navigation
  document.querySelectorAll('.site-header .wp-block-navigation__submenu-container')
          .forEach(elem => elem.insertAdjacentHTML('afterbegin',
              '<button aria-label="Close submenu" class="submenu-close-btn">Back</button>'));

  setupNavigationHandlers();
}

function setupNavigationHandlers() {
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.wp-block-navigation-submenu__toggle');
    if (toggle) handleSubmenuToggle(toggle);
    if (e.target.matches('.submenu-close-btn')) handleSubmenuClose(e.target);
    if (e.target.closest('.wp-block-navigation-item:not(.has-child)')) {
      document.querySelector('.wp-block-navigation__responsive-container-close')?.click();
    }
  });
}

function handleSubmenuToggle(toggle) {
  const parent = toggle.parentElement;
  const submenu = toggle.nextElementSibling;
  let handled = false;

  const onTransitionEnd = () => {
    if (!handled) {
      parent.classList.toggle('submenu-open');
      handled = true;
      submenu.removeEventListener('transitionend', onTransitionEnd);
    }
  };

  submenu.addEventListener('transitionend', onTransitionEnd);
}

function handleSubmenuClose(closeBtn) {
  const submenu = closeBtn.closest('.wp-block-navigation__submenu-container');
  const parentLi = submenu?.closest('li');

  if (parentLi) {
    // Remove the 'submenu-open' class from the parent <li>
    parentLi.classList.remove('submenu-open');

    // Target the sibling .wp-block-navigation-submenu__toggle
    const toggleButton = parentLi.querySelector('.wp-block-navigation-submenu__toggle');
    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'false');

      // Trigger the click event on the toggle button to sync state
      toggleButton.dispatchEvent(new Event('click'));
    }
  }
}
